import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import firebase from '../../store/firebase';
import { showToast } from "../../store/actions/toastAction";
import { 
  Grid, 
  Breadcrumbs, 
  Typography,
  TextField,
  IconButton,
  Button,
  FormControl,
  FormLabel
} from '@material-ui/core';
import { withStyles, emphasize } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Chip from '@material-ui/core/Chip';
import {
  isMobile,
  isBrowser
} from 'react-device-detect'
import { connect } from "react-redux";
import { bindActionCreators } from 'redux'
import { withRouter } from "react-router-dom";
import { getAuth, updateUser } from "firebase/auth";
import axios from 'axios';
import { FB_URL, SHOW_TOAST } from '../../store/actions/types';
import DailyToggleScheduler from './DailyToggleScheduler';
import LatestMEVerrEntry from './LatestMEVerrEntry';

// const StyledBreadcrumb = withStyles((theme) => ({
//   root: {
//     backgroundColor: theme.palette.grey[100],
//     height: theme.spacing(3),
//     color: theme.palette.grey[800],
//     fontWeight: theme.typography.fontWeightRegular,
//     '&:hover, &:focus': {
//       backgroundColor: theme.palette.grey[300],
//       textDecoration: 'none',
//     },
//     '&:active': {
//       boxShadow: theme.shadows[1],
//       backgroundColor: emphasize(theme.palette.grey[300], 0.12),
//       textDecoration: 'none',
//     },
//   },
// }))(Chip);


class monitor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      stats: {},           // Table 1: All except MEV buy/sold
      mevStats: {},        // Table 3: Only MEV buy/sold
      lcIn: 0,
      lcOut: 0,
      loading: false,
      data: [],
      LCPOOL: '',
      LCtoday: '',
      cleanLc: '',
      limit: '',
      newLimit: '',
      sendtoliq: '',
      bnbPriceCache: null,
      cacheExpiry: null,
      pointsOn: false,        // ← existing state
      MEVOn: false,
      showScheduler: false,   // ← NEW: controls visibility
    };
  }

  parsePoints = (value) => {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
      const match = value.match(/[-+]?\d*\.?\d+/);
      return match ? parseFloat(match[0]) : 0;
    }
    return 0;
  };

  toggleScheduler = () => {
    this.setState(prevState => ({
      showScheduler: !prevState.showScheduler
    }));
  };

handleToggle = async () => {
  const newValue = !this.state.pointsOn; // ✅ calculate first

  var updateObject = {};
   updateObject['patreon/LcExchangeon'] = newValue;
  try {
    var res = await axios.post(`${FB_URL}/m115-freshcard`, {
      params: {
        updates: updateObject,
      },
    });

    if (res.data && res.data.success === true) {
      this.setState({
        pointsOn: newValue, // ✅ set directly
      });
      console.log("success!");
    } else {
      console.log("Error:");
    }
  } catch (err) {
    console.log("Request failed:", err);
  }
};

handleMEVToggle = async () => {
  const newValue = !this.state.MEVOn; // ✅ calculate first

  var updateObject = {};
   updateObject['patreon/mevExchangeon'] = newValue;
  try {
    var res = await axios.post(`${FB_URL}/m115-freshcard`, {
      params: {
        updates: updateObject,
      },
    });

    if (res.data && res.data.success === true) {
      this.setState({
        MEVOn: newValue, // ✅ set directly
      });
      console.log("success!");
    } else {
      console.log("Error:");
    }
  } catch (err) {
    console.log("Request failed:", err);
  }
};

// === 1. FIRST: Update your handleToggle in the main class component ===

/* Inside YourMainComponent (the class where handleToggle lives) */
/* Replace your old handleToggle with this updated version */

// handleToggle = async (forceValue = null) => {   // ← NEW: optional parameter
//   let newValue;

//   if (forceValue !== null) {
//     newValue = forceValue;           // force ON (true) or OFF (false)
//   } else {
//     newValue = !this.state.pointsOn; // original toggle behavior (no argument)
//   }

//   var updateObject = {};
//   updateObject['patreon/LcExchangeon'] = newValue;

//   try {
//     var res = await axios.post(`${FB_URL}/m115-freshcard`, {
//       params: {
//         updates: updateObject,
//       },
//     });

//     if (res.data && res.data.success === true) {
//       this.setState({
//         pointsOn: newValue,
//       });
//       console.log(`success! → pointsOn set to ${newValue}`);
//     } else {
//       console.log("Error:");
//     }
//   } catch (err) {
//     console.log("Request failed:", err);
//   }
// };

  componentDidMount = async() => {
    //  try {
    //   this.exchangeRef = firebase.database.ref(this.db, 'patreon/LcExchangeon');   

    //   const snapshot = await get(this.exchangeRef);

    //   if (snapshot.exists()) {
    //     this.setState({
    //       pointsOn: snapshot.val() === true,
    //       loading: false,
    //     });
    //   } else {
    //     this.setState({ loading: false });
    //   }
    // } catch (error) {
    //   console.error("Error reading LcExchangeon:", error);
    //   this.setState({ loading: false });
    // }
    //////////////////////////////////////////////////////////////////
    var liqWallet = process.env.REACT_APP_TYPE_SERVER;
    if (liqWallet==='test') {
       console.log('liqWallet 2  test');
    };
    if (liqWallet==='live') {
       console.log('liqWallet 2 live');
    };
    const dbRef = firebase.database.ref('patreon');
    dbRef.on('value', (snapshot) => {

      const rawData = snapshot.val();
      if (rawData) {
        this.setState({
          LCPOOL: rawData.LCPOOL / 100,
          LCtoday: rawData.LCtoday / 100,
          limit: rawData.limit,
          pointsOn:  rawData.LcExchangeon,
          MEVOn:  rawData.mevExchangeon
        });
      }  
    })
  }

// Assuming your Firebase app is initialized elsewhere and imported if needed.
// If not, add: import { initializeApp } from 'firebase/app';
// const firebaseConfig = { ... };
// const app = initializeApp(firebaseConfig);
// const db = getDatabase(app);


  // fetchData = () => {
  //   const { startDate, endDate } = this.state;
  //   if (!startDate || !endDate) return;

  //   this.setState({ loading: true });

  //   // Format dates as strings matching your fdate format
  //   // IMPORTANT: Make sure these are in the EXACT same string format as stored in fdate
  //   const startStr = startDate.toISOString().slice(0, 10);           // "2026-01-16"
  //   const endStr   = endDate.toISOString().slice(0, 10) + "\uf8ff";  // "2026-01-16\uf8ff" to include all times on that day

  //   // If fdate includes time (e.g. "2026-01-16 14:30"), use full datetime strings:
  //   // const startStr = startDate.toISOString().replace('T', ' ').slice(0, 16); // "2026-01-16 00:00"
  //   // const endStr   = endDate.toISOString().replace('T', ' ').slice(0, 16);   // adjust end to 23:59 if needed

  //   const dbRef = firebase.database().ref('MEVDATA')
  //     .orderByChild('fdate')
  //     .startAt(startStr)
  //     .endAt(endStr);

  //   dbRef.once('value').then((snapshot) => {
  //     const rawData = snapshot.val();
  //     if (!rawData) {
  //       this.setState({
  //         stats: {}, mevStats: {}, lcIn: 0, lcOut: 0, data: [], loading: false
  //       });
  //       return;
  //     }

  //     const dataArray = Object.values(rawData);

  //     // Now dataArray is already filtered by date on the server!
  //     // You can remove the client-side date filter entirely, or keep a safety check

  //     // Rest of your logic stays the same...
  //     const statsMap = {};
  //     const mevMap = {};
  //     let lcInTotal = 0;
  //     let totalPoints = 0;
  //     let excludedPoints = 0;

  //     const pledgeTypes = ['Super Pledge confirmed', 'Flex Pledge confirmed', 'Pledge confirmed'];
  //     const mevTypes = ['MEV buy', 'MEV sold'];

  //     dataArray.forEach(item => {
  //       const type = item.actionType || 'Unknown';
  //       const points = this.parsePoints(item.pointsAdded);

  //       totalPoints += points;

  //       if (mevTypes.includes(type)) {
  //         if (!mevMap[type]) mevMap[type] = 0;
  //         mevMap[type] += points;
  //       } else {
  //         if (!statsMap[type]) statsMap[type] = 0;
  //         statsMap[type] += points;
  //       }

  //       if (pledgeTypes.includes(type)) {
  //         lcInTotal += points;
  //         excludedPoints += points;
  //       }

  //       if (mevTypes.includes(type)) {
  //         excludedPoints += points;
  //       }
  //     });

  //     const lcOutTotal = totalPoints - excludedPoints;

  //     this.setState({
  //       stats: statsMap,
  //       mevStats: mevMap,
  //       lcIn: lcInTotal,
  //       lcOut: lcOutTotal,
  //       data: dataArray,  // already filtered
  //       loading: false
  //     });
  //   }).catch(err => {
  //     console.error(err);
  //     this.setState({ loading: false });
  //   });
  // };
  ///////////////////////////////////////////////////////////////////////////////////
  // fetchData_jan22 = () => {
  //   const { startDate, endDate } = this.state;
  //   if (!startDate || !endDate) return;

  //   this.setState({ loading: true });
  //   const dbRef = firebase.database.ref('MEVDATA');
  //   dbRef.on('value', (snapshot) => {

  //     const rawData = snapshot.val();
  //     if (!rawData) {
  //       this.setState({
  //         stats: {}, mevStats: {}, lcIn: 0, lcOut: 0, data: [], loading: false
  //       });
  //       return;
  //     }

  //     const dataArray = Object.values(rawData);
  //       const filtered = dataArray.filter(item => {
  //         if (!item.fdate) return false;

  //         // Parse the Firebase timestamp string
  //         const itemDate = new Date(item.fdate);

  //         // Optional: validate it's a valid date
  //         if (isNaN(itemDate)) return false;

  //         // Compare with full datetime precision
  //         return itemDate >= startDate && itemDate <= endDate;
  //       });

  //     const statsMap = {};      // Table 1
  //     const mevMap = {};        // Table 3
  //     let lcInTotal = 0;
  //     let totalPoints = 0;
  //     let excludedPoints = 0;

  //     const pledgeTypes = ['Super Pledge confirmed', 'Flex Pledge confirmed', 'Pledge confirmed'];
  //     const mevTypes = ['MEV buy', 'MEV sold'];

  //     filtered.forEach(item => {
  //       const type = item.actionType || 'Unknown';
  //       const points = this.parsePoints(item.pointsAdded);

  //       totalPoints += points;

  //       // === Table 1 & 3: Split by type ===
  //       if (mevTypes.includes(type)) {
  //         if (!mevMap[type]) mevMap[type] = 0;
  //         mevMap[type] += points;
  //       } else {
  //         if (!statsMap[type]) statsMap[type] = 0;
  //         statsMap[type] += points;
  //       }

  //       // === Lc In: Only pledges ===
  //       if (pledgeTypes.includes(type)) {
  //         lcInTotal += points;
  //         excludedPoints += points;
  //       }

  //       // === MEV buy/sold are excluded from Lc out ===
  //       if (mevTypes.includes(type)) {
  //         excludedPoints += points;
  //       }
  //     });

  //     const lcOutTotal = totalPoints - excludedPoints;

  //     this.setState({
  //       stats: statsMap,
  //       mevStats: mevMap,
  //       lcIn: lcInTotal,
  //       lcOut: lcOutTotal,
  //       data: filtered,
  //       loading: false
  //     });
  //   }, { onlyOnce: true });
  // };

fetchData = () => {
  const { startDate, endDate } = this.state;
  if (!startDate || !endDate) return;

  this.setState({ loading: true });

  // Format dates to match how they're stored in Firebase (adjust format if needed!)
  const formatDate = (date) => {
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    // If fdate is only "YYYY-MM-DD", use: date.toISOString().split('T')[0]
  };

  const startStr = formatDate(startDate);
  const endStr   = formatDate(endDate);

  // Build the query — filter on server!
  const dbRef = firebase.database
    .ref('MEVDATA')
    .orderByChild('fdate')
    .startAt(startStr)
    .endAt(endStr);   // endAt is inclusive

  // Use .once() instead of .on() unless you really need real-time updates here
  dbRef.once('value', (snapshot) => {
    const rawData = snapshot.val();

    if (!rawData) {
      this.setState({
        stats: {},
        mevStats: {},
        lcIn: 0,
        lcOut: 0,
        data: [],
        loading: false
      });
      return;
    }

    // Now we only have data in the date range → much smaller!
    const filtered = Object.values(rawData).filter(item => {
      // Extra safety in case of bad data, but should be rare now
      return item.fdate && !isNaN(new Date(item.fdate).getTime());
    });

    const statsMap = {};
    const mevMap = {};
    let lcInTotal = 0;
    let totalPoints = 0;
    let excludedPoints = 0;

    const pledgeTypes = ['GIF Pledge confirmed', 'Super Pledge confirmed', 'Lc earned from Pledge', 'Flex Pledge confirmed', 'Pledge confirmed'];
    const mevTypes = ['MEV buy', 'MEV sold'];

    filtered.forEach(item => {
      const type = item.actionType || 'Unknown';
      const points = this.parsePoints(item.pointsAdded);

      totalPoints += points;

      if (mevTypes.includes(type)) {
        mevMap[type] = (mevMap[type] || 0) + points;
      } else {
        statsMap[type] = (statsMap[type] || 0) + points;
      }

      if (pledgeTypes.includes(type)) {
        lcInTotal += points;
        excludedPoints += points;
      }

      if (mevTypes.includes(type)) {
        excludedPoints += points;
      }
    });

    const lcOutTotal = totalPoints - excludedPoints;

    this.setState({
      stats: statsMap,
      mevStats: mevMap,
      lcIn: lcInTotal,
      lcOut: lcOutTotal,
      data: filtered,
      loading: false
    });
  }).catch(err => {
    console.error('MEVDATA fetch error:', err);
    this.setState({ loading: false });
  });
};

    handleStartDateChange = (date) => {
      if (date) {
        // Set to start of the selected hour
        date.setMinutes(0, 0, 0);
      }
      this.setState({ startDate: date }, () => {
        if (this.state.endDate) this.fetchData();
      });
    };

    handleEndDateChange = (date) => {
      if (date) {
        // Set to end of the selected hour
        date.setMinutes(59, 59, 999);
      }
      this.setState({ endDate: date }, () => {
        if (this.state.startDate) this.fetchData();
      });
    };

    fetchMEV = async () => {
        const blank = "";
        const res = await axios.post(`${FB_URL}/m110-getmevprice`, {
          aaa: blank,
          bbb: blank,
          ccc: blank,
        });
        
        const MEVprice = Number(res.data.MEVprice);   
        return MEVprice;
      }

  setLcLim = async() => {
   const { newLimit } = this.state;
   var updates = {}
   updates['/patreon/limit'] = newLimit * 100;

        var res = await axios.post(`${FB_URL}/m115-freshcard`, {
                params: {
                    updates: updates, //user wallet address                       
                }
              })

          if (res.data || res.data.success === true) {
           this.props.showToast({
             open: true,
             variant: "success",
             message: `New Lc Daily Limit set Successfully!`,
           });
          }
          else {
           this.props.showToast({
             open: true,
             variant: "error",
             message: "Failed to update limit",
           });
          };

      // await firebase.database.ref()
      //   .update(updates)
      //   .then(() => {
      //     this.props.showToast({
      //       open: true,
      //       variant: "success",
      //       message: `New Lc Daily Limit set Successfully!`,
      //     });
      //   })
      //   .catch((err) => {
      //     this.props.showToast({
      //       open: true,
      //       variant: "error",
      //       message: err.message || "Failed to update limit",
      //     });
      //   })
      }
 
  cleanLc = async() => {
  //  const { LCtoday } = this.state;
  //  var updates = {}
  //  var updateLcA = LCtoday * 100;
  //  var updateLc = updateLcA
  //  updates['/patreon/LCtoday'] = updateLc;
    const { cleanLc } = this.state;
    var updates = {};
    var updateLcA = cleanLc * 100;
    // Precise rounding to 5 decimal places
    var updateLc = Math.round(updateLcA * 100000) / 100000;
    updates['/patreon/LCtoday'] = updateLc;

        var res = await axios.post(`${FB_URL}/m115-freshcard`, {
              params: {
                  updates: updates, //user wallet address                       
              }
            })

        if (res.data || res.data.success === true) {
          this.props.showToast({
            open: true,
            variant: "success",
            message: `Changed Lc Spent today Successfully!`,
          });
        }
        else {
          this.props.showToast({
            open: true,
            variant: "error",
            message: "Failed to update Lc used this day",
          });
        };   
      // await firebase.database.ref()
      //   .update(updates)
      //   .then(() => {
      //     this.props.showToast({
      //       open: true,
      //       variant: "success",
      //       message: `Changed Lc Spent today Successfully!`,
      //     });
      //   })
      //   .catch((err) => {
      //     this.props.showToast({
      //       open: true,
      //       variant: "error",
      //       message: err.message || "Failed to update Lc used this day",
      //     });
      //   })

      }

  delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  exchangeOn = async() => {
    console.log('exchange on function');
    var updates = {};
    updates['/exchangepaused/paused'] = false;

       var res = await axios.post(`${FB_URL}/m115-freshcard`, {
            params: {
                updates: updates, //user wallet address                       
            }
          })

      if (res.data || res.data.success === true) {
        console.log('exchange on success!');
      }
      else {
         console.log('exchange on error!');
      };
  }

  exchangeOff = async() => {
    console.log('exchange off function');
    var updates = {};
    updates['/exchangepaused/paused'] = true;
    
       var res = await axios.post(`${FB_URL}/m115-freshcard`, {
            params: {
                updates: updates, //user wallet address                       
            }
          })

      if (res.data || res.data.success === true) {
         console.log('exchange off success!');
      }
      else {
         console.log('exchange off error!');
      };
  }

    // exchangeOff = async () => {
    //   try {
    //     await firebase.database.ref('exchangepaused/paused').set(true);
    //     console.log("Exchange is now PAUSED globally");
    //   } catch (err) {
    //     console.error("Exchange Failed to pause:", err);
    //   }
    // };

    // exchangeOn = async () => {
    //   try {
    //     await firebase.database.ref('exchangepaused/paused').set(false);
    //     console.log("Exchange is now RESUMED globally");
    //   } catch (err) {
    //     console.error("Exchange Failed to resume:", err);
    //   }
    // };

  // sendToLiq = async() => {
  //  const { sendtoliq, LCPOOL } = this.state;
  //  var updates = {}
  //  var go1 = false;
  //  var go2 = false
  //  var priceReset = false;
  //  var lcpool = LCPOOL;
  //  //var newlcpool = lcpool - (sendtoliq * 100);
  //  var newlcpool = lcpool - sendtoliq;


  //   const answerYes = prompt(
  //     `Are you sure you want to send ${sendtoliq} in liquidity to Me Vision \n ( Please type 'yes' if you want to proceed !) `
  //   )

  //   // if (answerYes === '' || answerYes === null || answerYes !== 'yes' || answerYes !== 'Yes' || answerYes !== 'y') {
  //  // if (answerYes === '' || answerYes === null) {
  //   if (answerYes !== 'yes' && answerYes !== 'Yes' && answerYes !== 'YES') {
  //     showToast({
  //       type: 'SHOW_TOAST',
  //       open: true,
  //       variant: 'warning',
  //       message: 'Liquidity send cancelled.'
  //     })

  //     return
  //   }

  //  const bnbAmount = await this.convertUsdToBnb(sendtoliq);
  
  //   console.log('sendToLiq 0: ', bnbAmount); //lc or $
  //   console.log('sendToLiq 1: ', this.props.userdetails[0].uid);

  //   const MEVStart = await this.checkAndUpdateMEVbuyStart(this.props.userdetails[0].uid);
  //   const MEVprice = await this.fetchMEV() //get MEV price before everything
  //   //PAUSE EXCHANGE!////////////////////////////////////////////////////////////
  //    //localStorage.setItem('exchange_paused', 'true');
  //    await this.exchangeOff();
  //   ////////////////////////////////////////////////////////////////////////////
  //   if (bnbAmount===false) { MEVStart = false }

  //   if (MEVStart === true) {
  //  //send BNB to safewallet 2 ///////////////////////////////////
  //      try {
  //             const auth = getAuth(); // Firebase Authentication instance

  //             const user = auth.currentUser;
  //             if (!user) { 
  //                 return;
  //             }
              
  //             // Get Firebase ID Token
  //           const idToken = await user.getIdToken();

  //           const res = await axios.post(`${FB_URL}/m108-buymevision`, {
  //                   params: {
  //                     wallet: '',
  //                     privateKeyEncrypted: this.props.userdetails[0].privateKey,
  //                     profile: '',
  //                     profile_n: '',
  //                     pledge_pers: '',
  //                     userEmail_trim: '',
  //                     companyName: '',
  //                     firstName: '',
  //                     lastName: '',
  //                     userID: '',
  //                     uid: this.props.userdetails[0].uid,
  //                     companyID: '',
  //                     amount: 0,
  //                     amountS: 0,
  //                       func: 23,
  //                     realpoints: 0,
  //                     iBB: 28,
  //                       transBNB: bnbAmount,
  //                     transMEV: '1941.46',
  //                     newMaxInBNB: 200,
  //                     setPrice: 1.4661521810774320470178,
  //                     transHash: '0xb6a9aa4e7cc2ffd77ac60d921fb13430261fe62e56a7a042bd4397d2058708de',
  //                     minTrans: "0.00000001",
  //                     newSafeWalletAddress: "0xBC29BB00739724Be72E3d0e81bBBe0DCCfe1Ff26",
  //                     withdrawAddress: '',
  //                     NEW_WALLET: "0x633Fbb79475344677aDD287AE1474d705535d667",
  //                       anywallet: "0x8f3eDCD646B247B702C80a3dcB987B6eCa6435b9",// "0xd0407B4BCB4A2D43F16D05F1bd53e00dcD275c7e",
  //                     sendToCustodial: false,
  //                     custodialwallet: "",
  //                     divfact: 0,
  //                     deployCode: process.env.REACT_APP_DEPLOYMENTCODE
  //                   }
  //             }, {
  //               headers: {
  //                   Authorization: `Bearer ${idToken}` // 🔒 Send the token in the header
  //               }
  //             });
              
  //              console.log('sendToLiq s: ', res.data.success);
  //              console.log('sendToLiq D: ', res.data.message);

  //              if (res.data.success===true) {
  //                go1 = true;
  //              }
  //              if (res.data.message==="BNB transferred successfully") {              
  //                go2 = true;
  //                let paramsX = {
  //                   type: SHOW_TOAST,
  //                   open: true,
  //                   variant: 'success',
  //                   message: 'Liquidity transfered successfully! Please wait 3 minutes for MEV price to reset.'
  //                 }
  //                 this.props.showToast(paramsX)
  //              }

  //           } catch (error) {
  //               console.log('sendToLiq err:', error);
  //           }
  //         }
  //     else{
  //       //  this.handleCloseAModal();
  //         let paramsX = {
  //         type: SHOW_TOAST,
  //         open: true,
  //         variant: 'warning',
  //         message: 'Please wait between 7 and 10 minutes before sending Liquidity again.'
  //       }
  //       this.props.showToast(paramsX)
  //     }
  //  //PAUSE///////////////////////////////////////////////////////
  //   await this.delay(180000); // 3 minutes
  //  //reset MEV price/////////////////////////////////////////////
  //     if ((go1===true) && (go2===true)) {
  //   const MEVStart = await this.checkAndUpdateMEVbuyStart(this.props.userdetails[0].uid);
  //   console.log('sendToLiq 4: ', MEVStart);
  //   if (MEVStart === true) {
  //  //set price generate MEV coins in liquidity pool ///////////////////////////////////
  //      try {
  //             const auth = getAuth(); // Firebase Authentication instance

  //             const user = auth.currentUser;
  //             if (!user) { 
  //                 return;
  //             }
              
  //             // Get Firebase ID Token
  //           const idToken = await user.getIdToken();
  //          // const MEVprice = await this.fetchMEV()
  //            console.log('sendToLiq 5: ', MEVprice);

  //           const res = await axios.post(`${FB_URL}/m108-buymevision`, {
  //                   params: {
  //                     wallet: '',
  //                     privateKeyEncrypted: this.props.userdetails[0].privateKey,
  //                     profile: '',
  //                     profile_n: '',
  //                     pledge_pers: '',
  //                     userEmail_trim: '',
  //                     companyName: '',
  //                     firstName: '',
  //                     lastName: '',
  //                     userID: '',
  //                     uid: this.props.userdetails[0].uid,
  //                     companyID: '',
  //                     amount: 0,
  //                     amountS: 0,
  //                       func: 1,
  //                     realpoints: 0,
  //                     iBB: 28,
  //                     transBNB: '',
  //                     transMEV: '1941.46',
  //                     newMaxInBNB: 200,
  //                       setPrice: MEVprice,//1.4661521810774320470178,
  //                     transHash: '0xb6a9aa4e7cc2ffd77ac60d921fb13430261fe62e56a7a042bd4397d2058708de',
  //                     minTrans: "0.00000001",
  //                     newSafeWalletAddress: "0xBC29BB00739724Be72E3d0e81bBBe0DCCfe1Ff26",
  //                     withdrawAddress: '',
  //                     NEW_WALLET: "0x633Fbb79475344677aDD287AE1474d705535d667",
  //                     anywallet: "0xd0407B4BCB4A2D43F16D05F1bd53e00dcD275c7e",
  //                     sendToCustodial: false,
  //                     custodialwallet: "",
  //                     divfact: 0,
  //                     deployCode: process.env.REACT_APP_DEPLOYMENTCODE
  //                   }
  //             }, {
  //               headers: {
  //                   Authorization: `Bearer ${idToken}` // 🔒 Send the token in the header
  //               }
  //             });
              
  //             console.log('sendToLiq 6: ', res.data);

  //              if (res.data.success===true) {
  //               priceReset = true;
  //                let paramsX = {
  //                   type: SHOW_TOAST,
  //                   open: true,
  //                   variant: 'success',
  //                   message: 'MEV price reset successfully!'
  //                 }
  //                 this.props.showToast(paramsX)
  //              }

  //           } catch (error) {
  //               console.log('sendToLiq err:', error);
  //           }
  //         }
  //     else{
  //       //  this.handleCloseAModal();
  //         let paramsX = {
  //         type: SHOW_TOAST,
  //         open: true,
  //         variant: 'warning',
  //         message: 'Please wait between 7 and 10 minutes before sending Liquidity again.'
  //       }
  //       this.props.showToast(paramsX)
  //      }
  //     }
  //     else{
  //       console.log('Something went wrong with the transfer of BNB.')
  //     }
  //  //update GIF in db/////////////////////////////////////////////
  //  //console.log('sendToLiq in db update:', error);
  //  if (priceReset===true) {
  //   console.log('sendToLiq 3: ', newlcpool * 100); //lc or $

  //   updates['/patreon/LCPOOL'] = newlcpool * 100;
  //      var res = await axios.post(`${FB_URL}/m115-freshcard`, {
  //           params: {
  //               updates: updates, //user wallet address                       
  //           }
  //         })

  //     if (res.data || res.data.success === true) {
  //         this.props.showToast({
  //           open: true,
  //           variant: "success",
  //           message: `Project Liquidity updated Successfully!`,
  //         });
  //     //ACTIVATE EXCHANGE!////////////////////////////////////////////////////////////
  //      //localStorage.removeItem('exchange_paused'); 
  //     await this.exchangeOn();
  //     ////////////////////////////////////////////////////////////////////////////
  //     }
  //     else {
  //         this.props.showToast({
  //           open: true,
  //           variant: "error",
  //           message: err.message || "Failed to update liquidity",
  //         });
  //      //ACTIVATE EXCHANGE!////////////////////////////////////////////////////////////
  //      // localStorage.removeItem('exchange_paused'); 
  //      await this.exchangeOn();
  //      ////////////////////////////////////////////////////////////////////////////       
  //     };
  //     // await firebase.database.ref()
  //     //   .update(updates)
  //     //   .then(() => {
  //     //     this.props.showToast({
  //     //       open: true,
  //     //       variant: "success",
  //     //       message: `Project Liquidity updated Successfully!`,
  //     //     });
  //     //   })
  //     //   .catch((err) => {
  //     //     this.props.showToast({
  //     //       open: true,
  //     //       variant: "error",
  //     //       message: err.message || "Failed to update liquidity",
  //     //     });
  //     //   })
  //     }
  //     else
  //      {
  //        this.props.showToast({
  //           open: true,
  //           variant: "error",
  //           message: "Price did not reset.",
  //         });
  //        //ACTIVATE EXCHANGE!////////////////////////////////////////////////////////
  //       //  localStorage.removeItem('exchange_paused'); 
  //       await this.exchangeOn();
  //        ////////////////////////////////////////////////////////////////////////////
  //      }
      
  //     // else{
  //     //   //  this.handleCloseAModal();
  //     //     let paramsX = {
  //     //     type: SHOW_TOAST,
  //     //     open: true,
  //     //     variant: 'warning',
  //     //     message: 'Please wait between 7 and 10 minutes before sending Liquidity again.'
  //     //   }
  //     //   this.props.showToast(paramsX)
  //     // }
  //   }

  sendToLiq = async() => {
   const { sendtoliq, LCPOOL } = this.state;
   var updates = {}
   var go1 = false;
   var go2 = false
   var priceReset = false;
   var lcpool = LCPOOL;
   //var newlcpool = lcpool - (sendtoliq * 100);
   var newlcpool = lcpool - sendtoliq;
   var liqWalletAddress;

    const answerYes = prompt(
      `Are you sure you want to send ${sendtoliq} in liquidity to Me Vision \n ( Please type 'yes' if you want to proceed !) `
    )

    // if (answerYes === '' || answerYes === null || answerYes !== 'yes' || answerYes !== 'Yes' || answerYes !== 'y') {
   // if (answerYes === '' || answerYes === null) {
    if (answerYes !== 'yes' && answerYes !== 'Yes' && answerYes !== 'YES') {
      showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'warning',
        message: 'Liquidity send cancelled.'
      })

      return
    }

   const bnbAmount = await this.convertUsdToBnb(sendtoliq);
  
    console.log('sendToLiq 0: ', bnbAmount); //lc or $
    console.log('sendToLiq 1: ', this.props.userdetails[0].uid);

    const MEVStart = await this.checkAndUpdateMEVbuyStart(this.props.userdetails[0].uid);
    const MEVprice = await this.fetchMEV() //get MEV price before everything
    //PAUSE EXCHANGE!////////////////////////////////////////////////////////////
     //localStorage.setItem('exchange_paused', 'true');
     if (bnbAmount > 0) {
      //continue
     }
     else {
        let paramsX = {
          type: SHOW_TOAST,
          open: true,
          variant: 'error',
          message: 'BNB transfer amount is zero. Transaction terminated.'
        }
        this.props.showToast(paramsX)
      return;
     }
     await this.exchangeOff();
    ////////////////////////////////////////////////////////////////////////////
    if (bnbAmount===false) { MEVStart = false }

    if (MEVStart === true) {
   //send BNB to safewallet 2 ///////////////////////////////////
    var liqWallet = process.env.REACT_APP_TYPE_SERVER;
    if (liqWallet==='test') {
       liqWalletAddress = "0xd0407B4BCB4A2D43F16D05F1bd53e00dcD275c7e"
    };
    if (liqWallet==='live') {
       liqWalletAddress = "0x8f3eDCD646B247B702C80a3dcB987B6eCa6435b9"
    };

       try {
              const auth = getAuth(); // Firebase Authentication instance

              const user = auth.currentUser;
              if (!user) { 
                  return;
              }
              
              // Get Firebase ID Token
            const idToken = await user.getIdToken();

            const res = await axios.post(`${FB_URL}/m108-buymevision`, {
                    params: {
                      wallet: '',
                      privateKeyEncrypted: this.props.userdetails[0].privateKey,
                      profile: '',
                      profile_n: '',
                      pledge_pers: '',
                      userEmail_trim: '',
                      companyName: '',
                      firstName: '',
                      lastName: '',
                      userID: '',
                      uid: this.props.userdetails[0].uid,
                      companyID: '',
                        amount: newlcpool,//0, //placeholder to use for func = 25
                      amountS: 0,
                        func: 25,
                      realpoints: 0,
                      iBB: 28,
                        transBNB: bnbAmount,
                      transMEV: '1941.46',
                      newMaxInBNB: 200,
                         setPrice: MEVprice,//1.4661521810774320470178,
                      transHash: '0xb6a9aa4e7cc2ffd77ac60d921fb13430261fe62e56a7a042bd4397d2058708de',
                      minTrans: "0.00000001",
                      newSafeWalletAddress: "0xBC29BB00739724Be72E3d0e81bBBe0DCCfe1Ff26",
                      withdrawAddress: '',
                      NEW_WALLET: "0x633Fbb79475344677aDD287AE1474d705535d667",
                      //anywallet: "0x8f3eDCD646B247B702C80a3dcB987B6eCa6435b9", //LIVE
                      //anywallet: "0xd0407B4BCB4A2D43F16D05F1bd53e00dcD275c7e", //TEST
                      anywallet: liqWalletAddress,
                      sendToCustodial: false,
                      custodialwallet: "",
                      divfact: 0,
                      deployCode: process.env.REACT_APP_DEPLOYMENTCODE,
                      captchaToken: '',
                    }
              }, {
                headers: {
                    Authorization: `Bearer ${idToken}` // 🔒 Send the token in the header
                }
              });
              
               console.log('sendToLiq s: ', res.data.success);
               console.log('sendToLiq D: ', res.data.message);

               if (res.data.success===true) {
                 let paramsX = {
                    type: SHOW_TOAST,
                    open: true,
                    variant: 'success',
                    message: 'Liquidity transfered Successfully! MEV price reset Successfully! Please wait 3 minutes for MEV price to reset.'
                  }
                  this.props.showToast(paramsX)
               }

            } catch (error) {
                console.log('sendToLiq err:', error);
            }
          }
      else{
        //  this.handleCloseAModal();
          let paramsX = {
          type: SHOW_TOAST,
          open: true,
          variant: 'warning',
          message: 'Please wait between 7 and 10 minutes before sending Liquidity again.'
        }
        this.props.showToast(paramsX)
      }
   //PAUSE///////////////////////////////////////////////////////

      
    }

  checkAndUpdateMEVbuyStart = async (uid) => {
    const userRef = firebase.database.ref('user/' + uid);
    var updates = {};
      
      try {
        const snapshot = await userRef.once('value');

        
        // const snapshot = await userRef.once('value');
        if (!snapshot.exists()) {
          
          return false;
        }
        

        const userData = snapshot.val();
        const MEVStart = userData.MEVStart || 0;
        const MEVsession = userData.MEVSession;
        const now = Date.now();
        const minSinceMEVStart = (now - MEVStart) / (1000 * 60); // Convert milliseconds to minutes

        //  if (MEVsession===false) {
        //    return false;
        //  }
        //  if (minSinceMEVStart < 2) {
        //    return false;
        //  }
        if (MEVsession===false && minSinceMEVStart < 3) {
          return false;
        }

       //Update local state before Firebase to ensure instant changes
       //this.setState({ isBuying: true });

        updates['/user/' + uid + '/MEVStart'] = now;
        updates['/user/' + uid + '/MEVSession'] = true;

       var res = await axios.post(`${FB_URL}/m115-freshcard`, {
            params: {
                updates: updates, //user wallet address                       
            }
          })

      if (res.data || res.data.success === true) {
         console.log('checkAndUpdateMEVbuyStart Success !');
        }
        else {
        console.log('checkAndUpdateMEVbuyStart Err');
        };

     // await firebase.database.ref().update(updates);
        return true;

      } catch (error) {
        
        return false;
      }
    };

getBNBprice = async () => {
  try {
    // Fixed: use .once() + proper Firebase syntax
    const dbRef = firebase.database.ref('MEVinfo/BNB_PRICE_IN_USD');
    const snapshot = await dbRef.once('value');
    
    const value = snapshot.val();
    console.log('getBNBprice success:', value);
    
    return value !== null && value > 0 ? value : null; // null = fallback to hardcoded
  } catch (error) {
    console.error('getBNBprice err:', error.message);
    return null;
  }
};

async convertUsdToBnb(usdAmount) {
  if (usdAmount <= 0) {
    return 0;
  }

  console.log('sendToLiq A: ', usdAmount);

  // Cache check (5-minute expiry)
  const now = Date.now();
  if (
    this.state.bnbPriceCache &&
    this.state.cacheExpiry &&
    now < this.state.cacheExpiry
  ) {
    return usdAmount / this.state.bnbPriceCache;
  }

  let bnbPrice = null;
  const FALLBACK_PRICE = 610; // ← Update this every few weeks (last resort only)

  try {
    // === LAYER 1: Primary → CoinGecko ===
    const response = await fetch(
      'https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd'
    );

    if (!response.ok) {
      throw new Error(`CoinGecko HTTP ${response.status}`);
    }

    const data = await response.json();
    bnbPrice = data.binancecoin?.usd;

    console.log('sendToLiq C (CoinGecko): ', bnbPrice);
  } catch (error) {
    console.error('CoinGecko fetch failed (NetworkError or other):', error.message || error);
  }

  // === LAYER 2: Binance (second fallback) ===
  if (!bnbPrice) {
    try {
      const binanceRes = await fetch(
        'https://api.binance.com/api/v3/ticker/price?symbol=BNBUSDT'
      );

      if (!binanceRes.ok) {
        throw new Error(`Binance HTTP ${binanceRes.status}`);
      }

      const binanceData = await binanceRes.json();
      bnbPrice = parseFloat(binanceData.price);

      console.log('sendToLiq Binance fallback: ', bnbPrice);
    } catch (binanceError) {
      console.error('Binance fallback failed:', binanceError.message || binanceError);
    }
  }

  // === LAYER 3: Firebase (third fallback) ===
  if (!bnbPrice) {
    try {
      bnbPrice = await this.getBNBprice();
      if (bnbPrice && bnbPrice > 0) {
        console.log('sendToLiq B (Firebase): ', bnbPrice);
      } else {
        bnbPrice = null; // force next fallback
      }
    } catch (fbError) {
      console.error('Firebase fallback failed:', fbError);
    }
  }

  // === FINAL HARDCODED FALLBACK ===
  if (!bnbPrice || bnbPrice <= 0) {
    bnbPrice = FALLBACK_PRICE;
    console.log('sendToLiq using hardcoded fallback:', FALLBACK_PRICE);
  }

  // Update cache ONLY when we got a real price (CoinGecko, Binance, or Firebase)
  if (bnbPrice !== FALLBACK_PRICE) {
    this.setState({
      bnbPriceCache: bnbPrice,
      cacheExpiry: now + 5 * 60 * 1000, // 5 minutes
    });
  }

  const bnbAmount = usdAmount / bnbPrice;
  console.log('sendToLiq D: ', bnbAmount);

  return bnbAmount;
}

 async convertUsdToBnb_old(usdAmount) {
    if (usdAmount <= 0) {
      return 0; // Handle invalid input
    }
    console.log('sendToLiq A: ', usdAmount);

    // Check cache first (expires after 5 minutes)
    const now = Date.now();
    if (
      this.state.bnbPriceCache &&
      this.state.cacheExpiry &&
      now < this.state.cacheExpiry
    ) {
      return usdAmount / this.state.bnbPriceCache;
    }

    try {
      // Fetch current BNB price in USD from CoinGecko
      const response = await fetch(
        'https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd'
      );
      
      if (!response.ok) {
        throw new Error('Failed to fetch BNB price');
      }

      const data = await response.json();
      const bnbPrice = data.binancecoin.usd;

      if (!bnbPrice) {
        throw new Error('Invalid price data received');
      }

      // Update cache
      this.setState({
        bnbPriceCache: bnbPrice,
        cacheExpiry: now + 5 * 60 * 1000, // 5 minutes
      });

     console.log('sendToLiq B: ', bnbPrice);

      // Return converted amount
      return usdAmount / bnbPrice;
    } catch (error) {
      console.error('Error converting USD to BNB:', error);
      // Fallback: Use a hardcoded recent price (update periodically)
      // As of Nov 5, 2025, 1 BNB ≈ $952.96 USD (from Bitget)
      const fallbackPrice = 632.93;//952.96;
      return 0;//usdAmount / fallbackPrice;
    }
  }

// async convertUsdToBnb_new_backup(usdAmount) {
//   if (usdAmount <= 0) {
//     return 0;
//   }

//   console.log('sendToLiq A: ', usdAmount);

//   // Cache check (5-minute expiry)
//   const now = Date.now();
//   if (
//     this.state.bnbPriceCache &&
//     this.state.cacheExpiry &&
//     now < this.state.cacheExpiry
//   ) {
//     return usdAmount / this.state.bnbPriceCache;
//   }

//   let bnbPrice;
//   const FALLBACK_PRICE = 632.93; // ← Update this every few weeks (check CoinGecko or Binance)

//   try {
//     // Primary: CoinGecko
//     const response = await fetch(
//       'https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd',
//       { cache: 'no-store' } // optional: force fresh data
//     );

//     if (!response.ok) {
//       throw new Error(`CoinGecko HTTP ${response.status}`);
//     }

//     const data = await response.json();
//     bnbPrice = data.binancecoin.usd;
//     console.log('sendToLiq C (CoinGecko): ', bnbPrice);
//   } catch (error) {
//     console.error('CoinGecko fetch failed:', error);

//     // Secondary fallback: Binance (very reliable for BNB/USDT)
//     try {
//       const binanceRes = await fetch(
//         'https://api.binance.com/api/v3/ticker/price?symbol=BNBUSDT'
//       );

//       if (!binanceRes.ok) {
//         throw new Error(`Binance HTTP ${binanceRes.status}`);
//       }

//       const binanceData = await binanceRes.json();
//       bnbPrice = parseFloat(binanceData.price);
//       console.log('sendToLiq Binance fallback: ', bnbPrice);
//     } catch (binanceError) {
//       console.error('Binance fallback also failed:', binanceError);
//       bnbPrice = FALLBACK_PRICE;
//       console.log('Using hardcoded fallback price:', FALLBACK_PRICE);
//     }
//   }

//   // Safety check
//   if (!bnbPrice || bnbPrice <= 0) {
//     bnbPrice = FALLBACK_PRICE;
//   }

//   // Update cache ONLY when we got a live price (not the hardcoded fallback)
//   if (bnbPrice !== FALLBACK_PRICE) {
//     this.setState({
//       bnbPriceCache: bnbPrice,
//       cacheExpiry: now + 5 * 60 * 1000, // 5 minutes
//     });
//   }

//   const bnbAmount = usdAmount / bnbPrice;
//   console.log('sendToLiq D: ', bnbAmount);

//   return bnbAmount;
// }

  render() {
    const { startDate, endDate, stats, mevStats, lcIn, lcOut, loading } = this.state;

    return (
<div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
    <div> <b>Lc Exchange:</b> 
        <input
          type="checkbox"
          checked={this.state.pointsOn}
          onChange={this.handleToggle}
        />
        {this.state.pointsOn ? "ON" : "OFF"}
      </div>
      <div>&nbsp;&nbsp;</div>
    <div> <b>MEV Exchange:</b> 
        <input
          type="checkbox"
          checked={this.state.MEVOn}
          onChange={this.handleMEVToggle}
        />
        {this.state.MEVOn ? "ON" : "OFF"}
      </div>
      <div>
         <button
          onClick={this.toggleScheduler}
          style={{
            padding: '5px 20px',
            fontSize: '14px',
            background: this.state.showScheduler ? '#28a745' : '#17a2b8',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            margin: '20px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          {this.state.showScheduler ? '🔽 Hide' : '📅 Show'} Daily Toggle Scheduler
        </button> 

        {/* Scheduler only appears when toggled ON */}
       {this.state.showScheduler && (
          <DailyToggleScheduler handleToggle={this.handleToggle} />
        )} 
      </div>

  <div
    style={{
      marginBottom: '20px',
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      gap: '15px',
      alignItems: isMobile ? 'flex-start' : 'center'
    }}
  >

    <div>
      <label><strong>From:</strong></label><br />
      <DatePicker
        selected={startDate}
        onChange={this.handleStartDateChange}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={60}
        dateFormat="yyyy-MM-dd HH:mm"
        placeholderText="Select start date & time"
        isClearable
      />
    </div>

    <div>
      <label><strong>To:</strong></label><br />
      <DatePicker
        selected={endDate}
        onChange={this.handleEndDateChange}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={60}
        dateFormat="yyyy-MM-dd HH:mm"
        placeholderText="Select end date & time"
        isClearable
      />
    </div>
  </div>


        {loading && <p>Loading data...</p>}

        {startDate && endDate && !loading && Object.keys(stats).length === 0 && Object.keys(mevStats).length === 0 && (
          <p>No data found for the selected date range.</p>
        )}

        {/* === TABLE 1: All Action Types EXCEPT MEV buy/sold === */}
        {(Object.keys(stats).length > 0 || Object.keys(mevStats).length > 0) && (
          <>
            <h3>Points by Action Type (Excl. MEV buy/sold)</h3>
            {Object.keys(stats).length > 0 ? (
              <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '30px' }}>
                <thead style={{ backgroundColor: '#f2f2f2' }}>
                  <tr>
                    <th>Action Type</th>
                    <th>Total Lc</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(stats).map(([type, total]) => (
                    <tr key={type}>
                      <td>{type}</td>
                      <td>{total.toFixed(3)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p style={{ marginBottom: '30px', fontStyle: 'italic' }}>No non-MEV actions in range.</p>
            )}

            {/* === TABLE 2: Lc Summary === */}
            <h3>Lc Summary</h3>
            <table border="1" cellPadding="10" style={{ width: '50%', borderCollapse: 'collapse', marginBottom: '30px' }}>
              <thead style={{ backgroundColor: '#e6f7ff' }}>
                <tr>
                  <th>Curr</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ fontWeight: 'bold' }}>Lc in</td>
                  <td>{lcIn.toFixed(3)}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: 'bold' }}>Lc out</td>
                  <td>{lcOut.toFixed(3)}</td>
                </tr>
              </tbody>
            </table>

            {/* === TABLE 3: MEV buy/sold Only === */}
            <h3>MEV Transactions</h3>
            {Object.keys(mevStats).length > 0 ? (
              <table border="1" cellPadding="10" style={{ width: '60%', borderCollapse: 'collapse' }}>
                <thead style={{ backgroundColor: '#fff4e6' }}>
                  <tr>
                    <th>Transaction Type</th>
                    <th>Total MEV</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(mevStats).map(([type, total]) => (
                    <tr key={type}>
                      <td>{type}</td>
                      <td>{total.toFixed(3)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p style={{ fontStyle: 'italic' }}>No MEV buy/sold transactions in range.</p>
            )}
          </>  
        )}

       <LatestMEVerrEntry />

         <h3>Set Limits</h3>
              <table border="1" cellPadding="10" style={{ width: '60%', borderCollapse: 'collapse' }}>
                <thead style={{ backgroundColor: '#fff4e6' }}>
                  <tr>
                    <th>Comp</th>
                    <th>Current limit</th>
                    <th>Set limit</th>
                    <th>-</th>
                  </tr>
                </thead>
                <tbody>
                    <tr>
                      <td>Lc Day Limit</td>
                      <td>{this.state.limit / 100}</td>
                      <td>
                        <TextField
                          id="limit"
                          aria-describedby="limit-address"
                          label="Lc Day Limit"
                          onChange={event => {
                            const { value } = event.target;
                            this.setState({
                               newLimit: value,
                            });
                         }}
                          InputProps={{
                            readOnly: false
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                          value={this.state.newLimit}
                         // fullWidth
                          required
                        />  
                      </td>
                      <td>
                        <Button
                            variant='contained'
                            onClick={this.setLcLim}
                            style={{ 
                              backgroundColor: '#4caf50',
                              color: 'white',
                              fontWeight: 'bold',
                              textTransform: 'none'
                            }}
                          >
                            Set Limit
                          </Button>
                      </td>
                    </tr>
                </tbody>
              </table>  

         <h3>Daily Lc spent</h3>
              <table border="1" cellPadding="10" style={{ width: '60%', borderCollapse: 'collapse' }}>
                <thead style={{ backgroundColor: '#fff4e6' }}>
                  <tr>
                    <th>Comp</th>
                    <th>Current Lc Spent</th>
                    <th>Set Lc</th>
                    <th>-</th>
                  </tr>
                </thead>
                <tbody>
                    <tr>
                      <td>Lc Day Spent</td>
                      <td>{Number(this.state.LCtoday).toFixed(3)}</td>
                      <td>
                        <TextField
                          id="lc"
                          aria-describedby="limit-address"
                          label="Lc Used"
                          onChange={event => {
                            const { value } = event.target;
                            this.setState({
                              cleanLc: value,
                            });
                         }}
                          InputProps={{
                            readOnly: false
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                          value={this.state.cleanLc}
                         // fullWidth
                          required
                        />  
                      </td>
                      <td>
                        <Button
                            variant='contained'
                            onClick={this.cleanLc}
                            style={{ 
                              backgroundColor: '#4caf50',
                              color: 'white',
                              fontWeight: 'bold',
                              textTransform: 'none'
                            }}
                          >
                            Reset Lc
                          </Button>
                      </td>
                    </tr>
                </tbody>
              </table>  

    <h3>GIF / Liquidity</h3>
              <table border="1" cellPadding="10" style={{ width: '60%', borderCollapse: 'collapse' }}>
                <thead style={{ backgroundColor: '#fff4e6' }}>
                  <tr>
                    <th>GIF</th>
                    <th>GIF NOW</th>
                    <th>Move liq</th>
                    <th>-</th>
                  </tr>
                </thead>
                <tbody>
                    <tr>
                      <td>GIF</td>
                      <td>{Number(this.state.LCPOOL).toFixed(3)}</td>
                      <td>
                        <TextField
                          id="sendliq"
                          aria-describedby="limit-address"
                          label="Send Liquidity"
                          onChange={event => {
                            const { value } = event.target;
                            this.setState({
                               sendtoliq: value,
                            });
                         }}
                          InputProps={{
                            readOnly: false
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                          value={this.state.sendtoliq}
                         // fullWidth
                          required
                        />  
                      </td>
                      <td>
                        <Button
                            variant='contained'
                            onClick={this.sendToLiq}
                            style={{ 
                              backgroundColor: '#4caf50',
                              color: 'white',
                              fontWeight: 'bold',
                              textTransform: 'none'
                            }}
                          >
                            MOVE
                          </Button>
                      </td>
                    </tr>
                </tbody>
              </table>
      </div>
    );
  }
}
     
const mapStateToProps = (state) => ({
  userdetails: state.userDialog.userDetails,
});
const mapDispatchToProps = (dispatch) => {
  return {
    showToast: params => dispatch(showToast(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(monitor)

